import { useAuthStore, useCurrentUserQuery } from '@host/auth'
import { useEffect, type ReactNode } from 'react'

/**
 * Поднимает сессию на старте.
 *
 * Два шага, и порядок между ними важен: сначала синхронно читается
 * хранилище (иначе гвард на первом кадре увидит гостя), затем сервер
 * подтверждает токен. Пока идёт подтверждение, пользователь уже работает —
 * оптимистично, потому что альтернатива это пустой экран на каждую загрузку.
 */
export function SessionProvider({ children }: { children: ReactNode }) {
  const hydrate = useAuthStore((state) => state.hydrate)
  const updateUser = useAuthStore((state) => state.updateUser)

  useEffect(() => {
    hydrate()
  }, [hydrate])

  const { data } = useCurrentUserQuery()

  useEffect(() => {
    if (data) updateUser(data)
  }, [data, updateUser])

  return children
}
